import { render, staticRenderFns } from "./ProductRule.vue?vue&type=template&id=74bd61da&scoped=true&"
import script from "./ProductRule.vue?vue&type=script&lang=js&"
export * from "./ProductRule.vue?vue&type=script&lang=js&"
import style0 from "./ProductRule.vue?vue&type=style&index=0&id=74bd61da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bd61da",
  null
  
)

export default component.exports